<script lang="ts">
    // import { ENode, ELine } from '@journeys/binaryWorker'
    // import vm /*, { tmp_uuidv4, UngappedJourney, ownedObjects }*/ from '@journeys/Journeys.viewmodel'

    // directives

    // utils
    // import HumanTime from '@shared/utils/HumanTime/HumanTime'
    // import { deepClone, requestFrame, cancelFrame, uid } from '@utils'

    // components
    import NodeTemplate from '@journeys/components/NodePartials/NodeTemplate.vue';

    // assets
    // import { TinyClockSVG, UserLegacySVG, CrossSVG } from '@shared/assets/vector/ui/IconsUI'
    import HSLColors from '@shared/components/ColorPickers/HSLColorValues';

    import { NodeFrame } from '@journeys/components/NodePartials/NodeAssets';
    import { onMounted, reactive, ref } from 'vue';
    // import { JourneyStatus } from '../Enums'

    // components
    // import SelectMany from '@shared/components/SelectMany/SelectMany.vue'

    // const toHumanTime = new HumanTime({ locale: 'sv' })

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'Partial_JourneyPreview',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            journey: any;
            index: number;
            newJourney?: boolean;
        }>(),
        {
            newJourney: false,
        }
    );

    // const { startMenu, account } = vm

    let previewRef = ref(),
        previewRect: DOMRect,
        dominantProps = reactive({
            preview: 0,
            content: 0,
            transition: false,
        }),
        content = props.journey.data?.content || {};

    onMounted(() => {
        // setPreviewSize()
        // setTimeout(setPreviewSize, 0) // ugly fix
        onVisible();

        window.addEventListener('resize', handlePageResizeEvent);
    });

    const setPreviewSize = () => {
        previewRect = previewRef.value.getBoundingClientRect();
        dominantProps.preview = Math.min(previewRect.height, previewRect.width);
        dominantProps.content = Math.max(props.journey.data.content.h, props.journey.data.content.w);
    };

    let resizeTimeout: NodeJS.Timeout;

    const handlePageResizeEvent = () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
            if (!previewRef.value) return;

            setPreviewSize();

            dominantProps.transition = true;

            resizeTimeout = setTimeout(() => (dominantProps.transition = false), 400);
        }, 300);
    };

    const onVisible = () => {
        new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    setPreviewSize();
                    // setTimeout(setPreviewSize, 0)
                    // handlePageResizeEvent()
                    observer.disconnect();
                }
            });
        }).observe(previewRef.value);
    };
</script>

<template>
    <div class="preview-container" ref="previewRef">
        <div
            class="preview-canvas"
            :style="[
                { height: journey.data.content.h + 'px', width: journey.data.content.w + 'px' },
                `transform: translate3d(-50%,-50%,0) scale(${dominantProps.preview / dominantProps.content})`,
                { transitionDuration: !dominantProps.transition ? '0s' : '' },
            ]">
            <svg class="line-canvas" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="frameClrDefault" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color: hsl(180, 100%, 14%)" />
                        <stop offset="100%" style="stop-color: hsl(180, 100%, 10%)" />
                    </linearGradient>
                    <marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
                        <path d="M 0 0 L 7 5 L 0 10 L 3 5 z" fill="darkcyan" />
                    </marker>
                </defs>
                <g
                    v-for="line in journey.data.lines"
                    :key="line.id"
                    class="line-group"
                    :style="`height: ${content.h}px; width: ${content.w}px; transform: translate3d(-50%,-50%,0) scale(1)`">
                    <path
                        class="line"
                        :d="`M ${line.runtime?.frVertex || `${content.l + line.x} ${content.t + line.y}`} L ${line.points.reduce((acc: string, { x, y }: any) => acc + ` ${content.l + x} ${content.t + y} `, '')} ${line.runtime?.toVertex || `${content.l + line.ex} ${content.t + line.ey}`}`"
                        stroke="darkcyan"
                        stroke-dasharray="6"
                        stroke-width="1.8"
                        fill="none"
                        marker-end="url(#arrow)" />

                    <circle
                        v-for="({ x, y }, pidx) in line.points"
                        :key="`${line.id}phbx${pidx}`"
                        :cx="content.l + x"
                        :cy="content.t + y"
                        r="7"
                        fill="#1f1c26"
                        opacity=".6" />
                </g>
            </svg>
            <div
                v-for="(node, index) in journey.data.nodes"
                :key="node.id"
                class="node"
                :style="[
                    { width: node.w + 'px', height: node.h + 'px', backgroundColor: node.fc },
                    `transform: translate3d(${content.l + node.x}px, ${content.t + node.y}px, 0px)`,
                ]">
                <NodeTemplate
                    :id="node.id"
                    :frame="node.f"
                    :frameColor="(HSLColors as Indexable<number, any>)[node.fc]"
                    :icon="node.i"
                    :iconColor="(HSLColors as Indexable<number, any>)[node.ic]"
                    class="canvas-node"
                    :class="node.f === NodeFrame.RoundedRect && 'frame-offset-rect'" />
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .preview-container {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.2s ease-out;
        transition-property: transform, box-shadow, margin, border, outline;
    }

    .preview-container .preview-canvas {
        display: block;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 50%;
        left: 50%;
        transform-origin: center;
        transition: transform 0.5s ease;
    }

    .preview-container .line-canvas {
        display: block;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 50%;
        left: 50%;
        transform-origin: center;
        transition: transform 0.5s ease;
    }
</style>
